import { Skeleton } from "@/components/ui/skeleton";
import { Card } from "@/components/ui/card";

export function ArticleSkeleton() {
    return (
        <div className="flex flex-col min-h-screen bg-background">
            {/* Header Placeholder */}
            <div className="h-20 w-full border-b border-border/40 mb-12" />

            <main className="flex-grow pt-12 pb-24 container mx-auto px-6 max-w-4xl">
                {/* Back Button Skeleton */}
                <div className="mb-12">
                    <Skeleton className="h-4 w-32 rounded-full" />
                </div>

                {/* Article Header Skeleton */}
                <header className="mb-12">
                    <div className="flex gap-3 mb-8">
                        <Skeleton className="h-6 w-24 rounded-full" />
                        <Skeleton className="h-6 w-20 rounded-full" />
                    </div>

                    <Skeleton className="h-12 w-3/4 rounded-xl mb-4" />
                    <Skeleton className="h-12 w-1/2 rounded-xl mb-8" />

                    <div className="flex items-center gap-8 py-8 border-y border-border/50">
                        <div className="flex items-center gap-3">
                            <Skeleton className="h-10 w-10 rounded-full" />
                            <div className="space-y-1">
                                <Skeleton className="h-3 w-16" />
                                <Skeleton className="h-4 w-24" />
                            </div>
                        </div>

                        <div className="flex items-center gap-3">
                            <Skeleton className="h-10 w-10 rounded-full" />
                            <div className="space-y-1">
                                <Skeleton className="h-3 w-16" />
                                <Skeleton className="h-4 w-24" />
                            </div>
                        </div>
                    </div>
                </header>

                {/* Featured Image Skeleton */}
                <div className="relative aspect-[21/9] rounded-[3rem] overflow-hidden shadow-luxury mb-16 border-4 border-card bg-card">
                    <Skeleton className="h-full w-full" />
                </div>

                {/* Content Skeleton */}
                <div className="space-y-4 max-w-none">
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-5/6" />
                    <div className="h-8" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-11/12" />
                    <Skeleton className="h-4 w-full" />
                </div>

                {/* Author Bio Skeleton */}
                <div className="mt-16 p-8 bg-card border border-border/50 rounded-[2rem] flex gap-6 items-center shadow-sm">
                    <Skeleton className="w-20 h-20 rounded-full flex-shrink-0" />
                    <div className="space-y-2 flex-1">
                        <Skeleton className="h-6 w-48" />
                        <Skeleton className="h-4 w-full" />
                        <Skeleton className="h-4 w-3/4" />
                    </div>
                </div>
            </main>
        </div>
    );
}
